import React from 'react';
import { Link } from 'react-router-dom';
import { GitFork, Upload, History, Search } from 'lucide-react';
import type { QuickAction } from '../../types/dashboard';

const quickActions: QuickAction[] = [
  {
    id: 'connect-repo',
    title: 'New Repo Monitor',
    description: 'Link your GitHub, GitLab, or Bitbucket project',
    icon: <GitFork className="w-5 h-5" />,
    path: '/repositories',
  },
  {
    id: 'quick-scan',
    title: 'Analyze Repo',
    description: 'Scan any public repo by URL without connecting',
    icon: <Search className="w-5 h-5" />,
    path: '/scan',
  },
  {
    id: 'upload-file',
    title: 'Upload Code',
    description: 'Upload a zip file of your code for review',
    icon: <Upload className="w-5 h-5" />,
    path: '/upload',
  },
  {
    id: 'view-history',
    title: 'View History',
    description: 'See all your past code reviews and suggestions',
    icon: <History className="w-5 h-5" />,
    path: '/history',
  },
];

export const QuickActionsSection: React.FC = () => {
  return (
    <div
      className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6"
      data-guide="quick-actions"
    >
      <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-4">Quick Actions</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions.map((action) => (
          <Link
            key={action.id}
            to={action.path}
            className="relative bg-white dark:bg-gray-800 rounded-lg p-4 text-left transition-colors duration-200 group border border-gray-200 dark:border-gray-700 hover:border-teal-500 focus:ring-2 focus:ring-teal-500 focus:outline-hidden cursor-pointer no-underline"
          >
            {action.description && (
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-gray-700 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none z-10">
                {action.description}
                <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-700" />
              </div>
            )}
            <div className="flex items-center gap-3">
              <div className="shrink-0 p-2 rounded-lg bg-teal-100 dark:bg-teal-900/30 text-teal-600 dark:text-teal-400">
                {action.icon}
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900 dark:text-white">{action.title}</h3>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
